import { render, staticRenderFns } from "./checkDelete.vue?vue&type=template&id=4c6e9608&scoped=true"
import script from "./checkDelete.vue?vue&type=script&lang=js"
export * from "./checkDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e9608",
  null
  
)

export default component.exports